import notify from "../../common/notify";
import { BudgetOptions } from "../../../data/seletboxOptions";
import { ReactComponent as DollarIcon } from "../../../assets/img/common/dollar-icon.svg";
import { ReactComponent as RemoveRowIcon } from "../../../assets/img/common/trash-red-icon.svg";
import { ReactComponent as PlusIcon } from "../../../assets/img/common/plus-purple-icon.svg";
import { currencyIcons } from "../../../utils/currencies";
const CustomSelectBox = ({ value, options, onChange }) => {
  return (
    <select
      onChange={onChange}
      value={value}
      className="w-full h-full non-appearance bg-transparent ml-2 px-2 focus:bg-[#f6f3f3] hover:bg-[#f4f1f1] hover:cursor-pointer rounded-md "
    >
      {options?.map((item, index) => (
        <option key={item + index} value={item}>
          {item}
        </option>
      ))}
    </select>
  );
};
const Separator = ({ flow = "col" }) => {
  return (
    <span
      className={` ${
        flow === "row" ? "w-full border-b h-1" : "w-1 mx-3 border-l-2 h-[95%]"
      }  border-custom-gray-500`}
    ></span>
  );
};

// MobileSubCategory Component
const MobileSubCategory = ({
  item,
  index,
  category,
  subCategoryLength,
  subCategory,
  budgetIndex,
  formik,
  handleAddSubCategory,
  handleDeleteSubCategory,
  handleChangeField,
  name,
  detail,
  budget,
  budgetAmountError,
  detailError,
  nameError,
}) => {
  return (
    <div className="w-full flex flex-col items-center py-2 px-3 mb-7 gap-y-3 ">
      <section className="flex h-full items-center w-full ">
        {(subCategoryLength <= 1 || subCategoryLength - 1 === index) && (
          <button
            type="button"
            onClick={handleAddSubCategory}
            className="min-w-[32px] min-h-[32px] rounded-full text-lg text-center flex justify-center items-center "
          >
            <PlusIcon />
          </button>
        )}
        {category === "Other Expenses" ? (
          <input
            value={name}
            onChange={(e) => handleChangeField(e, "name")}
            placeholder="title"
            type="text"
            className="input-without-style h-full focus:bg-[#f6f3f3] hover:bg-[#f4f1f1] transition-all duration-200 rounded-md px-3 w-full"
          />
        ) : (
          <CustomSelectBox
            options={BudgetOptions?.[category].subCategory}
            value={name}
            onChange={(e) => handleChangeField(e, "name")}
          />
        )}
      </section>
      <Separator flow="row" />
      <section className="w-full flex items-center h-full ">
        <input
          value={detail}
          onChange={(e) => handleChangeField(e, "detail")}
          placeholder="Details"
          type="text"
          className="input-without-style h-9 focus:bg-[#f8f7f7] bg-[#f6f3f3] transition-all duration-200 rounded-md px-3 w-full"
        />
      </section>
      <Separator flow="row" />
      <section className=" w-full h-full flex items-center font-medium whitespace-nowrap relative">
        <DollarIcon className="w-7 h-7 mr-1" />
        <input
          value={budget}
          onChange={(e) => handleChangeField(e, "budget")}
          placeholder="Budget"
          type="number"
          onWheel={(e) => e.target.blur()}
          className="input-without-style h-9 focus:bg-[#f8f7f7] bg-[#f6f3f3] transition-all duration-200 rounded-md px-3 w-full"
        />
      </section>
      <button
        type="button"
        onClick={handleDeleteSubCategory}
        className="w-full flex justify-center items-center text-[15px] p-1 border border-red-500 text-red-500 px-2 rounded-lg"
      >
        <RemoveRowIcon className="mr-1 h-5" />
        Remove Item
      </button>{" "}
      {formik.touched?.budgets && budgetAmountError ? (
        <p
          className={`w-full flex justify-start text-red-500 text-sm  mt-2 field-error-msg whitespace-nowrap pl-2`}
        >
          {budgetAmountError}
        </p>
      ) : null}
      {formik.touched?.budgets && detailError ? (
        <p
          className={`w-full flex justify-start text-red-500 text-sm  mt-2 field-error-msg whitespace-nowrap pl-2`}
        >
          {detailError}
        </p>
      ) : null}
      {formik.touched?.budgets && nameError ? (
        <p
          className={`w-full flex justify-start text-red-500 text-sm  mt-2 field-error-msg whitespace-nowrap pl-2`}
        >
          {nameError}
        </p>
      ) : null}
    </div>
  );
};

// DesktopSubCategory Component
const DesktopSubCategory = ({
  item,
  index,
  category,
  subCategoryLength,
  subCategory,
  budgetIndex,
  formik,
  handleAddSubCategory,
  handleDeleteSubCategory,
  handleChangeField,
  name,
  detail,
  budget,
  budgetAmountError,
  detailError,
  nameError,
}) => {
  return (
    <div className="w-full flex justify-between items-center h-12 py-2 px-3 rounded-full bg-custom-gray-200 mb-7">
      <section className="flex h-full items-center min-w-[33%] relative ">
        {(subCategoryLength <= 1 || subCategoryLength - 1 === index) && (
          <button
            type="button"
            onClick={handleAddSubCategory}
            className="min-w-[32px] min-h-[32px] rounded-full text-lg text-center flex justify-center items-center "
          >
            <PlusIcon />
          </button>
        )}
        {category === "Other Expenses" ? (
          <input
            value={name}
            onChange={(e) => handleChangeField(e, "name")}
            placeholder="title"
            type="text"
            className="input-without-style h-full focus:bg-[#f6f3f3] hover:bg-[#f4f1f1] transition-all duration-200 rounded-md px-3 w-full"
          />
        ) : (
          <CustomSelectBox
            options={BudgetOptions?.[category].subCategory}
            value={name}
            onChange={(e) => handleChangeField(e, "name")}
          />
        )}
        {formik.touched?.budgets && nameError ? (
          <span
            className={`text-red-500 text-sm  mt-1 field-error-msg absolute -bottom-[31px] -left-1 whitespace-nowrap pl-1`}
          >
            {nameError}
          </span>
        ) : null}
      </section>
      <section className="w-[50%] min-w-[100px] flex items-center h-full relative">
        <Separator />
        <input
          value={detail}
          onChange={(e) => handleChangeField(e, "detail")}
          placeholder="Details"
          type="text"
          className="input-without-style h-full focus:bg-[#f6f3f3] hover:bg-[#f4f1f1] transition-all duration-200 rounded-md px-3 w-full"
        />
        {formik.touched?.budgets && detailError ? (
          <span
            className={`text-red-500 text-sm  mt-1 field-error-msg absolute -bottom-[31px] -left-1 whitespace-nowrap pl-1`}
          >
            {detailError}
          </span>
        ) : null}
      </section>
      <Separator />
      <section className=" min-w-[7rem] h-full flex items-center font-medium whitespace-nowrap relative">
        <DollarIcon className="w-7 h-7 mr-1" />
        <input
          value={budget}
          onChange={(e) => handleChangeField(e, "budget")}
          placeholder="Budget"
          type="number"
          onWheel={(e) => e.target.blur()}
          className="input-without-style h-full focus:bg-[#f6f3f3] hover:bg-[#f4f1f1] transition-all duration-200 rounded-md px-3 w-full"
        />

        {formik.touched?.budgets && budgetAmountError ? (
          <span
            className={`text-red-500 text-sm  mt-1 field-error-msg absolute -bottom-[31px] -left-4 whitespace-nowrap pl-1`}
          >
            {budgetAmountError}
          </span>
        ) : null}
      </section>
      <button
        type="button"
        onClick={handleDeleteSubCategory}
        className="min-w-[32px] min-h-[32px] rounded-full text-sm flex justify-center items-center ml-3"
      >
        <RemoveRowIcon />
      </button>
    </div>
  );
};

// SubCategory Component
const SubCategory = ({
  item,
  index,
  category,
  subCategoryLength,
  subCategory,
  budgetIndex,
  formik,
}) => {
  // Function to calculate the last index of an array, considering it may be empty
  const calcLastIndex = (arr) => (arr.length > 0 ? arr.length - 1 : 0);

  // Destructuring relevant properties from the item and error object
  let {
    budget: budgetAmountError,
    detail: detailError,
    name: nameError,
  } = formik.errors?.budgets?.[budgetIndex]?.subCategory?.[index] ?? {};
  let { name, detail, budget } = item;

  // Function to set Formik field value for budgets
  const fomrikSetter = (val) => {
    formik.setFieldValue("budgets", val);
  };

  // Handler for changing input values within the sub-category
  const handleChangeField = (e, field) => {
    let budgetsClone = structuredClone(formik.values.budgets);
    budgetsClone[budgetIndex].subCategory[index][field] = e.target.value;
    fomrikSetter(budgetsClone);
  };

  // Handler for deleting a sub-category
  const handleDeleteSubCategory = () => {
    let budgetsClone = [...formik.values.budgets];
    budgetsClone[budgetIndex].subCategory.splice(index, 1);
    if (budgetsClone[budgetIndex].subCategory?.length < 1) {
      budgetsClone.splice(budgetIndex, 1);
    }
    fomrikSetter(budgetsClone);
  };

  // Function to check if sub-category fields have valid values
  const checkSubCategoryFieldsValue = () => {
    if (formik.values.budgets.length === 0) return true;
    let budgetsClone = [...formik.values.budgets];
    let lastBudget = budgetsClone[budgetIndex];
    const { name, detail, budget } =
      lastBudget.subCategory[calcLastIndex(lastBudget.subCategory)];
    if (!nameError && budget > 0 && !budgetAmountError && !detailError)
      return true;
    return false;
  };

  // Handler for adding a new sub-category
  const handleAddSubCategory = () => {
    if (checkSubCategoryFieldsValue()) {
      let budgetsClone = [...formik.values.budgets];
      budgetsClone[budgetIndex].subCategory.push({
        name:
          budgetsClone[budgetIndex] === "Other Expenses"
            ? ""
            : "Researcher Salary",
        detail: "",
        budget: 0.1,
      });
      fomrikSetter(budgetsClone);
    } else {
      // Notify and prompt the user to fill in all fields correctly
      formik.setFieldTouched("budgets", true);
      notify("Please fill in all the fields correctly", "error");
    }
  };

  // Render the desktop or mobile sub-category component based on screen size
  return (
    <>
      <div className="hidden mlg:flex">
        <DesktopSubCategory
          item={item}
          index={index}
          category={category}
          subCategoryLength={subCategoryLength}
          subCategory={subCategory}
          budgetIndex={budgetIndex}
          formik={formik}
          handleAddSubCategory={handleAddSubCategory}
          handleDeleteSubCategory={handleDeleteSubCategory}
          handleChangeField={handleChangeField}
          name={name}
          detail={detail}
          budget={budget}
          budgetAmountError={budgetAmountError}
          detailError={detailError}
          nameError={nameError}
        />
      </div>
      <div className="flex mlg:hidden">
        <MobileSubCategory
          item={item}
          index={index}
          category={category}
          subCategoryLength={subCategoryLength}
          subCategory={subCategory}
          budgetIndex={budgetIndex}
          formik={formik}
          handleAddSubCategory={handleAddSubCategory}
          handleDeleteSubCategory={handleDeleteSubCategory}
          handleChangeField={handleChangeField}
          name={name}
          detail={detail}
          budget={budget}
          budgetAmountError={budgetAmountError}
          detailError={detailError}
          nameError={nameError}
        />
      </div>
    </>
  );
};

// Export the SubCategory component
export default SubCategory;
